import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FaEdit, FaUserTimes } from "react-icons/fa";
import api from "../services/api";
import "./EditLastPayroll.css";

const EditLastPayroll = () => {
  const { id: businessId } = useParams();
  const navigate = useNavigate();

  const [payrollData, setPayrollData] = useState([]);
  const [payPeriodInfo, setPayPeriodInfo] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMostRecentPayrollData = async () => {
      try {
        const response = await api.get(`/payroll/recent/${businessId}`);

        if (Array.isArray(response.data) && response.data.length > 0) {
          setPayPeriodInfo({
            start_date: response.data[0].start_date,
            end_date: response.data[0].end_date,
            pay_date: response.data[0].pay_date,
            frequency: response.data[0].frequency,
          });
        }

        setPayrollData(Array.isArray(response.data) ? response.data : []);
        setError(null);
      } catch (err) {
        console.error("Error fetching recent payroll data:", err);
        setError("Failed to fetch payroll data. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchMostRecentPayrollData();
  }, [businessId]);

  const formatDate = (value) => {
    if (!value) return "—";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "—";
    return d.toLocaleDateString("en-US");
  };

  const formatMoney = (value) => {
    const num = parseFloat(value || 0);
    return num.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  };

  const handleDelete = async (id) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this record?"
    );

    if (!confirmed) return;

    try {
      await api.post(`/payroll/delete`, { ids: [id] });
      setPayrollData((prev) => prev.filter((record) => record.id !== id));
    } catch (err) {
      console.error("Error deleting payroll record:", err);
      alert("Failed to delete payroll record.");
    }
  };

  const handleEdit = (record) => {
    navigate(`/dashboard/business/${businessId}/edit-record/${record.id}`);
  };

  if (loading) {
    return <p className="edit-payroll-loading">Loading payroll data...</p>;
  }

  if (error) {
    return <p className="edit-payroll-error">{error}</p>;
  }

  return (
    <div className="edit-payroll-page">
      <div className="edit-payroll-header">
        <div>
          <p className="edit-payroll-subtitle">
            Review and update records from the most recent pay period.
          </p>
        </div>
      </div>

      {payrollData.length > 0 ? (
        <>
          <div className="edit-payroll-summary-grid">
            <div className="edit-payroll-summary-card">
              <div className="edit-payroll-summary-label">Start Date</div>
              <div className="edit-payroll-summary-value">
                {formatDate(payPeriodInfo.start_date)}
              </div>
            </div>

            <div className="edit-payroll-summary-card">
              <div className="edit-payroll-summary-label">End Date</div>
              <div className="edit-payroll-summary-value">
                {formatDate(payPeriodInfo.end_date)}
              </div>
            </div>

            <div className="edit-payroll-summary-card">
              <div className="edit-payroll-summary-label">Pay Date</div>
              <div className="edit-payroll-summary-value">
                {formatDate(payPeriodInfo.pay_date)}
              </div>
            </div>

            <div className="edit-payroll-summary-card">
              <div className="edit-payroll-summary-label">Frequency</div>
              <div className="edit-payroll-summary-value">
                {payPeriodInfo.frequency || "—"}
              </div>
            </div>
          </div>

          <div className="edit-payroll-card">
            

            <div className="edit-payroll-table-wrap">
              <table className="edit-payroll-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Gross Pay</th>
                    <th>Net Pay</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {payrollData.map((record) => (
                    <tr key={record.id}>
                      <td>{record.name || "—"}</td>
                      <td>{formatMoney(record.grosspay)}</td>
                      <td>{formatMoney(record.net_pay)}</td>
                      <td>
                        <div className="edit-payroll-actions">
                          <button
                            type="button"
                            onClick={() => handleEdit(record)}
                            className="edit-button-page"
                            aria-label={`Edit ${record.name || "record"}`}
                            title="Edit Record"
                          >
                            <FaEdit />
                          </button>

                          <button
                            type="button"
                            onClick={() => handleDelete(record.id)}
                            className="del-button-page"
                            aria-label={`Delete ${record.name || "record"}`}
                            title="Delete Record"
                          >
                            <FaUserTimes />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      ) : (
        <div className="edit-payroll-empty-card">
          <p className="message-edit-page">
            No payroll records found for the most recent pay period.
          </p>
        </div>
      )}
    </div>
  );
};

export default EditLastPayroll;



// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { FaEdit, FaUserTimes } from "react-icons/fa";
// import api from "../services/api";
// import "./EditLastPayroll.css";

// const EditLastPayroll = () => {
//     const { id: businessId } = useParams();
//     const [payrollData, setPayrollData] = useState([]);
//     const [payPeriodInfo, setPayPeriodInfo] = useState({});
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);

//     const navigate = useNavigate();

//     useEffect(() => {
//         const fetchMostRecentPayrollData = async () => {
//             try {
//                 const response = await api.get(`/payroll/recent/${businessId}`);
//                 if (response.data.length > 0) {
//                     setPayPeriodInfo({
//                         start_date: response.data[0].start_date,
//                         end_date: response.data[0].end_date,
//                         pay_date: response.data[0].pay_date,
//                         frequency: response.data[0].frequency,
//                     });
//                 }
//                 setPayrollData(response.data);
//                 setError(null);
//             } catch (err) {
//                 console.error("Error fetching recent payroll data:", err);
//                 setError("Failed to fetch payroll data. Please try again.");
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchMostRecentPayrollData();
//     }, [businessId]);


//     const handleDelete = async (id) => {
//         if (window.confirm("Are you sure you want to delete this record?")) {
//             await api.post(`/payroll/delete`, { ids: [id] });
//             setPayrollData((prev) => prev.filter((record) => record.id !== id));
//             // User confirmed
//         }
        
       
//     };

    

//     const handleEdit = (record) => {
//         navigate(`/dashboard/business/${businessId}/edit-record/${record.id}`);
//     };
    
    

    

//     if (loading) {
//         return <p>Loading payroll data...</p>;
//     }

//     if (error) {
//         return <p>{error}</p>;
//     }

//     return (
//         <div className="edit-payroll-page">
        
//             <h3>Edit Last Payroll</h3>
//             {payrollData.length > 0 ? (
//                 <>
//                     <div className="dates-edit-page">
//                     <span className="span-edit">
//                         Start Date: {new Date(payPeriodInfo.start_date).toLocaleDateString()} 
//                     </span>
//                     <span className="span-edit">
//                         End Date: {new Date(payPeriodInfo.end_date).toLocaleDateString()}
//                     </span>
//                     <span className="span-edit">
//                         Pay Date: {new Date(payPeriodInfo.pay_date).toLocaleDateString()} 
//                     </span>
//                     </div>
                    
//                     <table className="edit-payroll-table">
//                         <thead>
//                             <tr>
//                                 <th>Name</th>
//                                 <th>Gross Pay</th>
//                                 <th>Net Pay</th>
//                                 <th></th>
//                             </tr>
//                         </thead>
//                         <tbody>
//     {payrollData.map((record) => (
//         <tr key={record.id}>
//             <td>{record.name || ""}</td>
//             <td>{Number(record.grosspay)}</td>
//             <td>{Number(record.net_pay)}</td>
//             <td>
//                 <button
//                     onClick={() => handleEdit(record)} // Pass the entire record
//                     className="edit-button-page"
//                 >
//                     <FaEdit/>
//                 </button>
//                 <button
//                     onClick={() => handleDelete(record.id)}
//                     className="del-button-page"
//                 >
//                     <FaUserTimes/>
//                 </button>
//             </td>
//         </tr>
//     ))}
//     </tbody>

//                     </table>
                   
//                 </>
//             ) : (
//                 <p className="message-edit-page">No payroll records found for the most recent pay period.</p>
//             )}
//         </div>
//     );
// };

// export default EditLastPayroll;




// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import api from "../services/api";

// const EditLastPayroll = () => {
//     const { id: businessId } = useParams(); // Get business ID from URL
//     const [payrollData, setPayrollData] = useState([]);
//     const [payPeriodInfo, setPayPeriodInfo] = useState({});
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);

//     useEffect(() => {
//         const fetchMostRecentPayrollData = async () => {
//             try {
//                 const response = await api.get(`/payroll/recent/${businessId}`);
//                 if (response.data.length > 0) {
//                     setPayPeriodInfo({
//                         start_date: response.data[0].start_date,
//                         end_date: response.data[0].end_date,
//                         pay_date: response.data[0].pay_date,
//                         frequency: response.data[0].frequency,
//                     });
//                 }
//                 setPayrollData(response.data);
//                 setError(null);
//             } catch (err) {
//                 console.error("Error fetching recent payroll data:", err);
//                 setError("Failed to fetch payroll data. Please try again.");
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchMostRecentPayrollData();
//     }, [businessId]);

//     if (loading) {
//         return <p>Loading payroll data...</p>;
//     }

//     if (error) {
//         return <p>{error}</p>;
//     }

//     return (
//         <div className="view-payroll-page">
//             <h1>Payroll Records</h1>
//             {payrollData.length > 0 ? (
//                 <>
//                     <div>
//                          Start Date -{" "}
//                         {new Date(payPeriodInfo.start_date).toLocaleDateString()} | End Date -{" "}
//                         {new Date(payPeriodInfo.end_date).toLocaleDateString()} | Pay Date -{" "}
//                         {new Date(payPeriodInfo.pay_date).toLocaleDateString()} | Frequency -{" "}
//                         {payPeriodInfo.frequency}
//                     </div>
//                     <table className="payroll-table">
//                         <thead>
//                             <tr>
//                                 <th>Name</th>
//                                 <th>Gross Pay</th>
//                                 <th>Net Pay</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {payrollData.map((record) => (
//                                 <tr key={record.id}>
//                                     <td>{record.name || ""}</td>
//                                     <td>{Number(record.grosspay)}</td>
//                                     <td>{Number(record.net_pay)}</td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </>
//             ) : (
//                 <p>No payroll records found for the most recent pay period.</p>
//             )}
//         </div>
//     );
// };

// export default EditLastPayroll;